module.exports = __webpack_public_path__ + "static/media/mob_footer_background.33173cae.svg";